import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { connectModalContainerContextToComponent } from '../../../../../contexts/ModalContext/ModalContext';
import { fetchTagList } from '../../../../../redux/slices/tagListSlice/tagListSlice';
import TagListTable from './TagListTable/TagListTable';
import NewTagModal from '../../modals/NewTagModal/NewTagModal';
import { RaaRoles } from '../../../../../utility/SecurityRules';
import HasRolePrivileges from '../../../../highorder/HasRolePrivileges';

function TagListLayout({ setModalJSX }) {
  const dispatch = useDispatch();
  dispatch(fetchTagList());

  const handleOpenCreateNewTagModal = () => {
    setModalJSX(<NewTagModal />);
  };

  return (
    <>
      <div className="row">
        <div className="col">
          <h2>Tags</h2>
        </div>
        <div className="col text-right">
          <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleOpenCreateNewTagModal}
            >
              New Tag
            </button>
          </HasRolePrivileges>
        </div>
      </div>
      <hr className="my-4" />
      <div className="row">
        <div className="col">
          <TagListTable />
        </div>
      </div>
    </>
  );
}

TagListLayout.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
};

export { TagListLayout };
export default connectModalContainerContextToComponent(TagListLayout);
